module.exports = "pegasus/assets/circle-linkedin.png";